import { useState } from 'react';

export const useAuditDrawer = () => {
    const [drawerOpened, setDrawerOpened] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState({});

    const onClickCard = (order) => {
        setSelectedOrder(order);
        setDrawerOpened(true);
    };

    const toggleDrawer = () => {
        setDrawerOpened(!drawerOpened);
        if (drawerOpened) {
            setSelectedOrder({});
        }
    };

    return {
        drawerOpened,
        selectedOrder,
        onClickCard,
        toggleDrawer
    };
};